module.exports = __webpack_public_path__ + "static/img/LUCAS-WOOTTON.f9125ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/LUCAS-WOOTTON.jpg
// module id = LMdn
// module chunks = 0